import { render } from "./AddRecensementPage.vue?vue&type=template&id=cc8c4fee&ts=true"
import script from "./AddRecensementPage.vue?vue&type=script&lang=ts"
export * from "./AddRecensementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__